import posthog from 'posthog-js'
import env from '@/helpers/env'

let initialized = false

export const initPosthog = (apiKey) => {
  if (initialized) return
  if (!apiKey) return
  const apiHost = env.get('POSTHOG_HOST') || 'https://us.i.posthog.com'
  posthog.init(apiKey, {
    api_host: apiHost,
    // Only create person profiles when identify() is called — avoids polluting
    // the person table with anonymous visitors who never log in.
    person_profiles: 'identified_only',
    // Persist flag assignments across the anonymous → identified transition so
    // a user always sees the same A/B variant before and after login.
    bootstrap: {},
    capture_pageview: false, // Vue Router handles navigation; we capture manually
    autocapture: true,
  })
  initialized = true
}

export default posthog
